import { faRotateRight } from '@fortawesome/free-solid-svg-icons'
import type { FC } from 'react'

import ActionButton from '@/components/ActionButton'

interface Props {
  onClick: () => void
  disabled?: boolean
}

const ResetButton: FC<Props> = ({ onClick, disabled = false }) => (
  <ActionButton
    label="Reset Section"
    icon={faRotateRight}
    onClick={onClick}
    disabled={disabled}
  />
)

export default ResetButton
